<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    title="说明内容配置"
    width="700px"
    :before-close="close"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
  >
    <div>
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="100px"
        size="small"
      >
        <template v-for="(item, index) in groups">
          <div :key="index" class="content-container">
            <div class="operation">
              <el-button
                size="mini"
                type="primary"
                :disabled="index == 0"
                icon="el-icon-top"
                @click="move(index, 'up')"
              ></el-button>
              <el-button
                size="mini"
                type="primary"
                :disabled="index == groups.length - 1"
                icon="el-icon-bottom"
                @click="move(index, 'down')"
              ></el-button>
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="deleteGroup(index)"
              ></el-button>
            </div>
            <el-form-item label="标题" prop="title">
              <el-input
                style="width:180px"
                v-model="item.title"
                placeholder="标题"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="内容" prop="content">
              <el-select v-model="item.type" class="input-width" size="small" @change="(val) => handleOptionsChange(val, index)">
                <el-option
                  v-for="type in contentOptions"
                  :key="type.value"
                  :value="type.value"
                  :label="type.label"
                ></el-option>
              </el-select>
              <el-select v-if="item.type == 1" v-model="item.propertyId" class="input-width" size="small">
                <el-option
                  v-for="type in propertes"
                  :key="type.id"
                  :value="type.id"
                  :label="type.propertyName"
                ></el-option>
              </el-select>
              <el-input v-if="item.type == 2" style=" display:block;width: 370px" type="textarea" v-model="item.content" :rows="4"></el-input>
            </el-form-item>
          </div>
        </template>
        <el-form-item>
          <el-button size="small" type="primary" @click="add">+说明</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">取消</el-button>
      <el-button type="primary" size="small" @click="save">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Array
    },
    propertes: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {},
      rules: {},
      groups: [
        {
          title: "",
          type: "",
          content: "",
          propertyId: ""
        }
      ],
      contentOptions: [
        {
          label: "文本",
          value: 2
        },
        {
          label: "属性",
          value: 1
        }
      ]
    };
  },
  created() {
    this.groups = this.content
  },
  methods: {
    handleOptionsChange(val, index) {
      this.groups[index].content = ''
      this.groups[index].propertyId = ''
    },
    close() {
      this.$emit("update:visible", false);
    },
    checkForm() {
      let pass;
      this.$refs.form.validate(valid => {
        pass = valid;
      });
      return pass;
    },
    move(i, type) {
      let list = this.$utils.handleMoveArr(this.groups, type, i);
      this.$set(this, "groups", list);
    },
    deleteGroup(i) {
      this.groups.splice(i, 1);
    },
    add() {
      this.groups.push({
        title: "",
        type: "",
        content: "",
        propertyId: ""
      });
    },
    save() {
      if (!this.checkForm()) return;
      this.$emit('set', this.groups)
      this.close()
    }
  }
};
</script>
<style lang="less">
.edit-dialog {
  .content-container {
    position: relative;
    margin-bottom: 16px;
    border-bottom: 1px dashed #ccc;
    .operation {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 9;
    }
  }
  .input-width {
    width: 180px;
    margin-bottom: 16px;
    margin-right: 10px;
  }
}
</style>
